import { createFileRoute, redirect } from "@tanstack/react-router";
import { validateCreateUserWizardSearch } from "@/features/admin/utils/createUserWizard";

export const Route = createFileRoute("/_app/users/create-user/")({
    validateSearch: validateCreateUserWizardSearch,
    beforeLoad: ({ search }) => {
        throw redirect({
            to: "/users/create-user/details",
            search: search.userId ? { userId: search.userId } : {},
        });
    },
});
